<template>
  <div>
    <div class="row" v-for="(employee, index) in employees" :key="index">
      <div class="col-md-12">
        <base-button simple block type="warning" v-on:click="showRows('user_' + index)">{{employee.first_name + ' ' + employee.last_name}}</base-button>
      </div>
      <div class="col-md-12 ml-auto mr-auto">
        <div :class="'user_' + index" class="row" style="display: none;" >
          <div class="col-md-12 ml-auto mr-auto">
            <blockquote class="blockquote">
              <div class="row">
                <base-input class="col-md-4" label="Project full name in system">
                  <select v-model="employee.project_id" class="form-control">
                    <option v-for="project in projects" :value="project.project_id" :key="project.project_id">{{project.full_name}}</option>
                  </select>
                </base-input>
                <base-input class="col-md-4" label="Employee role in system">
                  <select v-model="employee.type_id" class="form-control">
                    <option v-for="type in types" :value="type.type_id" :key="type.type_id">{{type.name}}</option>
                  </select>
                </base-input>
                <base-input class="col-md-4" label="Wage per hour"
                            v-model="employee.rate_per_hour"
                            placeholder="Wage per hour">
                </base-input>

                <div class="col-lg-12 ml-auto mr-auto"></div>
                <base-input class="col-md-4"
                            label="Login"
                            v-model="employee.user_name"
                            placeholder="user-name">
                </base-input>
                <base-input class="col-md-4"
                            label="Email"
                            v-model="employee.email"
                            placeholder="email">
                </base-input>
                <base-input class="col-md-4"
                            label="Phone"
                            v-model="employee.phone_number"
                            placeholder="phone">
                </base-input>
                <base-input class="col-md-8">
                  <label>About Employee</label>
                  <textarea rows="4" cols="80"
                            class="form-control"
                            placeholder=""
                            v-model="employee.description">
                </textarea>
                </base-input>
                <base-input class="col-md-2 col-6" style="margin-top: 15px">
                  <base-checkbox class="mb-3" v-model="employee.is_confirm">
                    Confirmed
                  </base-checkbox>
                </base-input>
                <base-input class="col-md-2 col-6" style="margin-top: 15px">
                  <base-checkbox class="mb-3" v-model="employee.is_delete">
                    Deleted
                  </base-checkbox>
                </base-input>
              </div>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {showElement} from "../../plugins/axios";

  export default {
      name: "setting-table",
      props: ['employees', 'projects', 'types'],
      data(){
        return{

        }
      },
      methods:{
        showRows(className){showElement(className)}
      },
    }
</script>

<style scoped>

</style>
